import { SSO_SET_DATA } from "src/redux/actions/ssoLinks";

import { setSsoDefaults } from "src/common/shared/featureSettings";
import { SSOLinkI } from "src/types/SSOLink";
import { OBTS_SET_DATA } from "src/redux/actions";

export interface SSOLinksAction {
  type: typeof SSO_SET_DATA | typeof OBTS_SET_DATA;
  payload: SSOLinkI[];
}

const ssoLinks = (
  state: SSOLinkI[] = [],
  action: SSOLinksAction
): SSOLinkI[] => {
  let result;
  switch (action.type) {
    case SSO_SET_DATA:
      result = setSsoDefaults(action.payload);
      return result;
    default:
      return state;
  }
};

export default ssoLinks;
